import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { TilesSection } from "../components/WhatsNew/TilesSection";
import news from "../data/news.json";

const newsItems = news;
export default function NewsPage(): ReactElement {
  return (
    <TilesSection
      cards={newsItems}
      empty={<Typography variant="h4">No news items available.</Typography>}
      hasHero={true}
    />
  );
}
